const {
    PROJECTS,
} = require('../../../env.config');

export const isRetope = () => process.env.NEXT_PUBLIC_PROJECT_NAME === PROJECTS.RETOPE;
